import {ValueObject} from '@s-ui/domain'

export class PaymentInitiatedTransactionsValueObject extends ValueObject {
  #isPaymentInitiated

  constructor({isPaymentInitiated}) {
    super()
    this.#isPaymentInitiated = isPaymentInitiated
  }

  static create = ({isPaymentInitiated}) => {
    return new PaymentInitiatedTransactionsValueObject({isPaymentInitiated})
  }

  get isPaymentInitiated() {
    return this.#isPaymentInitiated
  }

  toJSON = () => {
    return {
      isPaymentInitiated: this.#isPaymentInitiated
    }
  }
}
